import { CustomNotification } from '@/models/custom-notification.model';
import { ActionTree } from 'vuex';
import { RootState } from '../types';
import { NotificationState } from './types';
import uuidv4 from 'uuid/v4';

export const actions: ActionTree<NotificationState, RootState> = {
    addError({ commit }: any, notificationInfo: { title: string, message: string, logData: any }) {
        const notification: CustomNotification = {
            uuid: uuidv4(),
            type: 'ERROR',
            title: notificationInfo.title,
            message: notificationInfo.message,
            createdAt: Date.now(),
        };

        if (notificationInfo.logData) {
            console.error('ERROR', notificationInfo.logData);
        }

        commit('addNotification', notification);
    },
    addWarning({ commit }: any, notificationInfo: { title: string, message: string, logData: any }) {
        const notification: CustomNotification = {
            uuid: uuidv4(),
            type: 'WARNING',
            title: notificationInfo.title,
            message: notificationInfo.message,
            createdAt: Date.now(),
        };

        if (notificationInfo.logData) {
            console.log('WARNING', notificationInfo.logData);
        }

        commit('addNotification', notification);
    },
    addSuccess({ commit }: any, notificationInfo: { title: string, message: string, logData: any }) {
        const notification: CustomNotification = {
            uuid: uuidv4(),
            type: 'SUCCESS',
            title: notificationInfo.title,
            message: notificationInfo.message,
            createdAt: Date.now(),
        };

        if (notificationInfo.logData) {
            console.log('SUCCESS', notificationInfo.logData);
        }

        commit('addNotification', notification);
    },
    removeNotification({ commit }: any, notificationUuid: string) {
        commit('removeNotification', notificationUuid);
    },
    clearNotifications({ commit }: any) {
        commit('clearNotifications');
    },
};
